(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.product-addon-picker').forEach(initPicker);
  }

  function initPicker(pickerEl) {
    var formId      = pickerEl.dataset.formId;
    var blockId     = pickerEl.dataset.blockId;
    var modal       = document.getElementById('product-addon-modal-' + blockId);
    var labelEl     = pickerEl.querySelector('[data-addon-selection-label]');
    var priceEl     = pickerEl.querySelector('[data-addon-price-label]');
    var deselectBtn = pickerEl.querySelector('.product-addon-picker__deselect');

    var selectedAddon = null; // { variantId, title }

    // ── Tile selection & re-click to open modal ───────────────────────────

    pickerEl.querySelectorAll('.product-addon-tile').forEach(function (tileLabel) {
      var radio = tileLabel.querySelector('input[type="radio"]');
      if (!radio) return;

      // radio "change" fires on the first click when the tile is unselected
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        selectAddon(radio);
      });

      // clicking an already-selected tile won't fire "change" again,
      // so we use a click listener to detect that re-click and open the modal
      tileLabel.addEventListener('click', function (e) {
        if (e.target.closest('.product-addon-tile__info-btn')) return;
        if (radio.checked && selectedAddon && selectedAddon.variantId === radio.dataset.variantId) {
          e.preventDefault();
          openModalFromTile(tileLabel);
        }
      });
    });

    // ── Info button always opens modal ────────────────────────────────────

    pickerEl.querySelectorAll('.product-addon-tile__info-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal({
          title:       btn.dataset.title || '',
          description: btn.dataset.description || '',
          images:      JSON.parse(btn.dataset.images || '[]'),
        });
      });
    });

    function selectAddon(radio) {
      selectedAddon = {
        variantId: radio.dataset.variantId,
        title:     radio.dataset.productTitle,
        price:     radio.dataset.price,
      };

      if (labelEl) labelEl.innerHTML = selectedAddon.title;
      if (priceEl) priceEl.innerHTML = selectedAddon.price;
      if (deselectBtn) deselectBtn.removeAttribute('hidden');

      pickerEl.querySelectorAll('.product-addon-tile').forEach(function (tile) {
        tile.classList.toggle('is-selected', tile.contains(radio));
      });
    }

    if (deselectBtn) {
      deselectBtn.addEventListener('click', function () {
        pickerEl.querySelectorAll('.product-addon-tile input[type="radio"]').forEach(function (r) {
          r.checked = false;
        });
        pickerEl.querySelectorAll('.product-addon-tile').forEach(function (tile) {
          tile.classList.remove('is-selected');
        });
        selectedAddon = null;
        if (labelEl) labelEl.innerHTML = '<em>None selected</em>';
        if (priceEl) priceEl.innerHTML = '<em></em>';
        deselectBtn.setAttribute('hidden', '');
      });
    }

    function openModalFromTile(tileLabel) {
      var btn = tileLabel.querySelector('.product-addon-tile__info-btn');
      if (!btn) return;
      openModal({
        title:       btn.dataset.title || '',
        description: btn.dataset.description || '',
        images:      JSON.parse(btn.dataset.images || '[]'),
      });
    }

    // ── ATC interception ──────────────────────────────────────────────────
    // capture:true puts us ahead of the theme's product-form web component.
    // stopImmediatePropagation cancels the event before it can bubble to it.

    var form = formId ? document.getElementById(formId) : null;
    if (form) {
      form.addEventListener('submit', async function (e) {
        if (!selectedAddon) return; // no add-on chosen; let the form submit normally

        e.preventDefault();
        e.stopImmediatePropagation();

        var formData    = new FormData(form);
        var mainVariant = formData.get('id');
        if (!mainVariant) {
          console.warn('[AddonPicker] Could not read variant ID from product form.');
          return;
        }

        setLoading(true);

        try {
          // Ask the cart drawer (and any other listeners) which sections to re-render,
          // mirroring what the theme's ProductForm does before every add-to-cart.
          var sectionsToBundle = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle },
          }));

          var resp = await fetch('/cart/add.js', {
            method:  'POST',
            headers: {
              'Content-Type':    'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items: [
                { id: Number(mainVariant),             quantity: 1 },
                { id: Number(selectedAddon.variantId), quantity: 1 },
              ],
              sections: sectionsToBundle.join(','),
            }),
          });

          var responseJson = await resp.json();

          if (!resp.ok) {
            console.error('[AddonPicker]', responseJson.description || responseJson.message || 'Cart error');
            setLoading(false);
            return;
          }

          // Fetch current cart state and attach the re-rendered section HTML,
          // then dispatch cart:change with baseEvent "variant:add" — this is
          // exactly what ProductForm does, and is what causes the drawer to open.
          var cartContent = await (await fetch('/cart.js')).json();
          cartContent.sections = responseJson.sections;

          setLoading(false);

          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          }));

        } catch (err) {
          console.error('[AddonPicker] Network error:', err);
          setLoading(false);
        }
      }, { capture: true });
    }

    function setLoading(isLoading) {
      // Target every submit button tied to this form (main + sticky bar)
      document.querySelectorAll('[type="submit"][form="' + formId + '"]').forEach(function (btn) {
        if (isLoading) {
          btn.disabled = true;
          if (!btn.dataset.origText) btn.dataset.origText = btn.textContent;
          btn.textContent = 'Adding…';
        } else {
          btn.disabled = false;
          btn.textContent = btn.dataset.origText || 'Add to cart';
        }
      });
    }

    // ── Modal ─────────────────────────────────────────────────────────────

    if (!modal) return;

    var overlay  = modal.querySelector('.product-addon-modal__overlay');
    var closeBtn = modal.querySelector('.product-addon-modal__close');
    var titleEl  = modal.querySelector('.product-addon-modal__title');
    var descEl   = modal.querySelector('.product-addon-modal__description');
    var track    = modal.querySelector('.product-addon-modal__track');
    var prevBtn  = modal.querySelector('.product-addon-modal__prev');
    var nextBtn  = modal.querySelector('.product-addon-modal__next');
    var dotsEl   = modal.querySelector('.product-addon-modal__dots');

    var images       = [];
    var currentIndex = 0;

    function openModal(opts) {
      images = opts.images || [];
      titleEl.textContent = opts.title;
      var tmp = document.createElement('textarea');
      tmp.innerHTML = opts.description;
      descEl.innerHTML = tmp.value;
      buildCarousel();
      goTo(0);
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function buildCarousel() {
      track.innerHTML = '';
      dotsEl.innerHTML = '';
      var multi = images.length > 1;

      images.forEach(function (src, i) {
        var slide = document.createElement('div');
        slide.className = 'product-addon-modal__slide';
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        slide.appendChild(img);
        track.appendChild(slide);

        if (multi) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-addon-modal__dot';
          dot.setAttribute('aria-label', 'Image ' + (i + 1));
          dot.addEventListener('click', function () { goTo(i); });
          dotsEl.appendChild(dot);
        }
      });

      prevBtn.style.display = multi ? '' : 'none';
      nextBtn.style.display = multi ? '' : 'none';
    }

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, images.length - 1));
      track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      dotsEl.querySelectorAll('.product-addon-modal__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === images.length - 1;
    }

    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    document.addEventListener('keydown', function (e) {
      if (modal.hasAttribute('hidden')) return;
      if (e.key === 'Escape')      closeModal();
      if (e.key === 'ArrowLeft')   goTo(currentIndex - 1);
      if (e.key === 'ArrowRight')  goTo(currentIndex + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
